import { TCreateInternalDatasourceParams } from '@commenda/types/src/datasource/types';
import { fetcher } from '@commenda/utils';
import { DataSourceType } from '@prisma/client';

const createInternalDatasource = async (
  params: TCreateInternalDatasourceParams
) => {
  const response = await fetcher(`datasource`, {
    method: 'POST',
    body: { ...params, type: DataSourceType.INTERNAL },
  });

  return response;
};

export { createInternalDatasource };
